import React from 'react';
import { Link, useParams } from 'react-router-dom';

// !
// ! Version 1 of the app will scrape articles from Reddit and/or Twitter
// ! and will not have an article editor
// !

const ArticleEditor = () => {
  const { articleId } = useParams();

  return (
    <>
      <Link to={'/articles'} className="btn btn-primary btn-sm mb-4">
        Back
      </Link>
      <h1 className="text-lg font-semibold">Article editor</h1>

      <p className="text-sm text-base-content/60">{articleId}</p>
    </>
  );
};

export default ArticleEditor;
